import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {ParcelsService} from "../../../../services/parcels/parcels.service";
import {ShipmentService} from "../../../../open-api-generated/services/shipment.service";
import {PublicService} from "../../../../open-api-generated/services/public.service";
import {ParcelHistory} from "../../../../open-api-generated/models/parcel-history";

@Component({
  selector: 'app-public-shipment-tracking',
  templateUrl: './public-shipment-tracking.component.html',
  styleUrls: ['./public-shipment-tracking.component.scss']
})
export class PublicShipmentTrackingComponent implements OnInit {
  activeCardName = null;
  internalWaybill = null;
  parcelHistoryObjects: ParcelHistory[] = [];
  error = false;
  activeLanguage = null;
  browserLanguage = null;
  availableLanguages = ['pl', 'ro'];

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private parcelsService: ParcelsService,
    private shipmentService: ShipmentService,
    private publicService: PublicService,
  ) {

  }

  ngOnInit() {
    this.browserLanguage = (navigator.language).split('-')[0];
    this.setDefaultLang();
    this.internalWaybill = this.route.snapshot.paramMap.get('id');
    if (null !== this.internalWaybill) {
      this.searchShipmentHistory(this.internalWaybill);
    }
  }

  exists: boolean = true;
  statusesEmpty: boolean = false;

  searchShipmentHistory(internalWaybill: string): void {
    this.statusesEmpty = false;
    this.publicService.appV2PublicShipmentHistory({
        internalNumber: internalWaybill,
      }
    ).subscribe(
      (response: any): void => {
        this.exists = true;
        this.parcelHistoryObjects = response.history.parcels;
        window.history.pushState(null, null, `/tracking/${internalWaybill}`);
        this.error = false;
        console.log(this.parcelHistoryObjects)

        for (let object of this.parcelHistoryObjects) {
          this.activeCardName = object.waybill;
          if (0 === object.history.length || null === object.history) {
            this.statusesEmpty = true;
          }
          return;
        }
      },
      (e: any) => {
        this.exists = false;
        console.log(e);
        this.error = true;
      }
    );
  }

  setDefaultLang() {
    const lastSelectedLanguage = localStorage.getItem('language');
    let languageToSet = 'ro';
    if (lastSelectedLanguage == null) {
      if (this.availableLanguages.indexOf(this.browserLanguage) > -1) {
        languageToSet = this.browserLanguage;
      }
    } else {
      languageToSet = lastSelectedLanguage;
    }
    localStorage.setItem('language', languageToSet);
    this.translate.setDefaultLang(languageToSet);
    this.activeLanguage = languageToSet;
  }

  onChangeLanguage(selectedLanguage) {
    if (this.availableLanguages.indexOf(selectedLanguage) > -1) {
      localStorage.setItem('language', selectedLanguage);
      this.translate.setDefaultLang(selectedLanguage);
      this.activeLanguage = selectedLanguage;
    }
  }

  activeCardChanged(cardName: string): void {
    this.activeCardName = cardName;
  }
}
